
import React from 'react'
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import Icon from 'react-icons-kit';
import {chevronLeft} from 'react-icons-kit/fa/chevronLeft';

import * as actions from '../../store/actions';
import { topLevelPage } from '../../util/topLevelPage';

import styles from './TopPageLink.module.css';

// Closes the loop on a subpage: the subpage list under a level 0 section is one
// way in, and this is the way back out. Always aimed at the level 0 section rather
// than the immediate parent, since that is the page a reader thinks of as the main
// page even from two levels down.
const TopPageLink = props => {

  const {topPage, setCurrentPage} = props;

  // A level 0 page is already the main page, and an unresolvable parentId leaves
  // nothing to link to.
  if (!topPage) return null;

  return (
    // The href on its own changes nothing: ReadingPane reads the page out of
    // pages.currentPage and never looks the slug up off the URL, so the dispatch
    // is what actually swaps the content.
    <Link
      className={styles.Link}
      to={'/manual/' + topPage.slug}
      aria-label={`Back to ${topPage.title}`}
      onClick={() => setCurrentPage(topPage.slug)}>
      <Icon className={styles.Chevron} size={12} icon={chevronLeft}/>
      <span className={styles.LinkText}>{topPage.title}</span>
    </Link>
  )
}

const mapStateToProps = ({pages}, ownProps) => {
  const allPages = pages.pages ? pages.pages : {};
  const own = allPages[ownProps.id];

  return {
      topPage: (own && own.parentId) ? topLevelPage(own, allPages) : false
  }
}
const mapDispatchToProps = dispatch => {
  return {
      setCurrentPage: (slug) => dispatch(actions.setCurrentPage(slug))
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(TopPageLink)
